import { QuestionTypeEnum } from '@/models/Question';
import {
  Bars2Icon,
  CodeBracketIcon,
  CodeBracketSquareIcon,
  NumberedListIcon,
  PencilSquareIcon,
  PuzzlePieceIcon,
  QuestionMarkCircleIcon,
  VideoCameraIcon,
  RectangleStackIcon,
} from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/24/solid';

type QuestionTypeIconProps = {
  type: QuestionTypeEnum;
  className?: string;
};

const iconMap: Record<QuestionTypeEnum, React.ElementType> = {
  [QuestionTypeEnum.CODE]: CodeBracketSquareIcon,
  [QuestionTypeEnum.DND_POSITIONAL]: Bars2Icon,
  [QuestionTypeEnum.DND_ORDENATION]: NumberedListIcon,
  [QuestionTypeEnum.TRUE_OR_FALSE]: CheckIcon,
  [QuestionTypeEnum.QUIZ]: QuestionMarkCircleIcon,
  [QuestionTypeEnum.TEXT]: VideoCameraIcon,
  [QuestionTypeEnum.CODE_EDITOR]: CodeBracketIcon,
  [QuestionTypeEnum.BLOCK]: PuzzlePieceIcon,
  [QuestionTypeEnum.WRITING]: PencilSquareIcon,
  [QuestionTypeEnum.FILL_IN_THE_BLANK]: CodeBracketSquareIcon,
  [QuestionTypeEnum.FLASHCARD]: RectangleStackIcon,
};

export default function QuestionTypeIcon({
  type,
  className = 'w-5 h-5',
}: QuestionTypeIconProps) {
  const Icon = iconMap[type] ?? QuestionMarkCircleIcon;
  return <Icon className={className} />;
}
